/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { GblContext } from "providers/formatter";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import clsx from "clsx";
import { Loading, useRedirect, useTranslate } from "react-admin";
import { Paper, Grid } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { TableHead, TableFooter, TableRow, TableCell, Tooltip } from "@material-ui/core";
import { TableHead as MuiTableHead } from "mui-datatables";
import MuiTranslateTable from "components/MuiTranslateTable";
import ActionMenu from "components/ActionMenu";
import BoxHeader from "components/BoxHeader";
import ButtonFooter from "components/ButtonFooter";
//import NavRight from "components/NavRightSide";
import PopupTable from "components/PopupTable";
import DialogSelectTemplate from "./DialogSelectTemplate";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import { getJvDetail, createJvDetail, createJvFrDetail } from "services/generalLedger";
import { getActiveDimListByModuleName } from "services/dimension";
import Model from "models/glJv";
import SnackbarUtils from "utils/SnackbarUtils";

const Create = (props) => {
  const translate = useTranslate();
  const classes = props.useStyles();
  const { basePath, formFields, formFieldsDetail, copyMode } = props;
  const redirect = useRedirect();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [initData, setInitData] = useStateWithCallbackLazy({
    JvhSeq: -1,
    JvhDate: new Date(),
    Prefix: "",
    JvhNo: "Auto",
    JvhSource: "",
    Status: "Draft",
    Description: "",
    Detail: [],
    DimHList: {
      Dim: [],
    },
    UserModified: localStorage.getItem("UserName"),
  });
  const { settingAll, NumberFormat, ToNumber, ToNumberFixedFormat, FixedSumValue } = useContext(GblContext);
  const { SettingSystem } = settingAll;
  const [initNewRow, setInitNewRow] = useState({
    index: -1,
    JvhSeq: -1,
    JvdSeq: -1,
    DeptCode: "",
    AccCode: "",
    Description: "",
    CurCode: SettingSystem.DefaultCurrencyCode,
    CurRate: SettingSystem.DefaultCurrencyRate,
    CrAmount: 0,
    CrBase: 0,
    DrAmount: 0,
    DrBase: 0,
    IsOverWrite: true,
    DimList: {
      Dim: [],
    },
  });
  const [selectTemplateDialog, setSelectTemplateDialog] = useState(false);
  const [originalData, setOriginalData] = useState();
  const methods = useForm({ defaultValues: initData });

  const { handleSubmit, reset, getValues } = methods;

  function useForceUpdate() {
    const [value, setState] = useState(true);
    return () => setState(!value);
  }

  const forceUpdate = useForceUpdate();

  const disableFormEnter = (e) => {
    if (e.key === "Enter" && e.target.localName !== "textarea") e.preventDefault();
  };

  const onSubmit = async () => {
    const values = getValues();
    setBtnLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));

    setTimeout(() => {
      setInitData(
        (state) => ({
          ...state,
          ...values,
        }),
        (nextState) => Save(nextState)
      );
    }, 500);
  };

  const CloseSelectTemplateDialog = (newTemplateData, templateType) => {
    if (templateType === "1") {
      fetchJvFr(newTemplateData);
      setSelectTemplateDialog(false);
    } else if (templateType === "2") {
      fetchAllocateJV(newTemplateData);
      setSelectTemplateDialog(false);
    } else {
      setSelectTemplateDialog(false);
    }
  };

  const menuControlProp = [
    { name: "Back", fnc: () => redirect("list", basePath) },
    { name: "Add", disabled: true },
    { name: "Edit", disabled: true },
    { name: "Void", disabled: true },
    { name: "Copy", disabled: true },
    { name: "Template", fnc: () => setSelectTemplateDialog(true) },
    { name: "Print", disabled: true },
  ];

  const fetchDimListByModule = useCallback(async (mounted) => {
    if (originalData) {
      setInitNewRow((state) => ({
        ...state,
        DimList: {
          Dim: originalData,
        },
      }));
    } else {
      const { Data } = await getActiveDimListByModuleName(10, 1, "GL-D");

      const original = _.cloneDeep(Data);
      setOriginalData(original);

      setInitNewRow((state) => ({
        ...state,
        DimList: {
          Dim: Data,
        },
      }));
    }

    if (mounted) {
      setLoading(false);
    }
  }, []);

  const fetchJvFr = useCallback(async (response) => {
    setLoading(true);
    if (response) {
      const newModel = Object.assign({}, response);
      newModel.JvhNo = "Auto";
      newModel.JvhSeq = -1;
      newModel.JvhDate = new Date();
      newModel.Status = "Draft";
      newModel.JvhSource = "";
      setInitData(newModel);
      reset(newModel);
      localStorage.removeItem("template");
      localStorage.removeItem("templateType");
    }
    setLoading(false);
  }, []);

  const fetchAllocateJV = useCallback(async (response) => {
    setLoading(true);
    if (response) {
      const newModel = Object.assign({}, response);
      newModel.JvhNo = "Auto";
      newModel.JvhSeq = -1;
      newModel.JvhDate = new Date();
      newModel.Description = `Total Amount ${response.AllocateAmt} allocated ${response.AllocateUnit} units`;
      newModel.Status = "Draft";
      newModel.JvhSource = "";
      newModel.Detail.forEach((i) => (i.Description = `${i.DrQty > 0 ? i.DrQty : i.CrQty} allocated units`));
      setInitData(newModel);
      reset(newModel);
      localStorage.removeItem("template");
      localStorage.removeItem("templateType");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    let mounted = true;
    if (copyMode != 0) {
      async function fetchJvDetail() {
        const response = await getJvDetail(localStorage.getItem("jvId"));
        if (response) {
          //const oldPrefix = response.Prefix;
          //const oldJvhNo = response.JvhNo;
          response.JvhSeq = Model.JvhSeq;
          response.JvhDate = Model.JvhDate;
          response.JvhNo = Model.JvhNo;
          response.Status = Model.Status;
          response.JvhSource = "";
          response.Detail.forEach((item) => {
            item.JvhSeq = -1;
            item.JvdSeq = -1;
          });

          switch (copyMode) {
            case 2:
              //Copy and reverse
              response.Detail.forEach((item) => {
                if (item.CrAmount === 0) {
                  item.CrAmount = item.DrAmount;
                  item.CrBase = item.DrBase;
                  item.DrAmount = 0;
                  item.DrBase = 0;
                } else {
                  item.DrAmount = item.CrAmount;
                  item.DrBase = item.CrBase;
                  item.CrAmount = 0;
                  item.CrBase = 0;
                }
              });
              //response.Description = `${oldPrefix}${oldJvhNo} description: ${response.Description}`;
              break;
            case 3:
              //Copy to new JV
              response.Detail.forEach((item) => {
                item.CrAmount = 0;
                item.CrBase = 0;
                item.DrAmount = 0;
                item.DrBase = 0;
              });
              break;
            case 4:
              //Copy to template
              const { Code, InternalMessage, UserMessage } = await createJvFrDetail(response);
              if (Code === 0) {
                SnackbarUtils.success(UserMessage, function () {
                  redirect("show", "/glJvFr", InternalMessage, response);
                });
              }
              break;
            default:
              break;
          }
          setInitData(response);
          reset(response);
          localStorage.removeItem("jvCopyMode");
          localStorage.removeItem("jvId");
        }
        if (mounted) {
          setLoading(false);
        }
      }
      fetchJvDetail();
    }
    let templateType = localStorage.getItem("templateType");
    let template = JSON.parse(localStorage.getItem("template"));

    if (templateType === "1") {
      fetchJvFr(template);
    }
    if (templateType === "2") {
      fetchAllocateJV(template);
    }

    //fetchDimHListByModule(mounted);
    fetchDimListByModule(mounted);
    return function cleanup() {
      mounted = false;
    };
  }, []);

  const [showAdd, setShowAdd] = useState(false);
  const [editIndex, setEditIndex] = useState("");

  const AddNewRow = () => {
    //originalData.forEach((i) => (i.Value = null));
    setInitNewRow((state) => ({
      ...state,
      DimList: {
        Dim: originalData,
      },
    }));
    setEditIndex("");
    setShowAdd(true);
  };

  const UpdateRow = (value) => {
    setEditIndex(value);
    setShowAdd(true);
  };

  const SaveFromPopup = (arr, row) => {
    const index = arr.Detail.findIndex((el) => el.index === editIndex);
    row.DrBase = NumberFormat(row.DrBase);
    row.CrBase = NumberFormat(row.CrBase);

    if (editIndex !== "") {
      //update
      arr.Detail[index] = row;
      setInitData(arr);
      setShowAdd(false);
    } else {
      //create
      if (arr.Detail) {
        row.index = arr.Detail.length;
        arr.Detail = [...arr.Detail, row];
        setInitData(arr);
        setShowAdd(false);
      }
    }
    //reset dimension value
    fetchDimListByModule(true);
  };

  const CancelFromPopup = () => {
    setShowAdd(false);
  };

  const columns = [
    {
      name: "index",
      label: " ",
      options: {
        filter: false,
        viewColumns: false,
        customBodyRender: (value) => {
          return (
            <>
              <EditIcon
                fontSize="small"
                color="primary"
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => UpdateRow(value)}
              />
            </>
          );
        },
      },
    },
    {
      name: "DeptCode",
      label: "Dept.",
    },
    {
      name: "AccCode",
      label: "Account #",
    },
    {
      name: "AccDesc",
      label: "Account Name",
    },
    {
      name: "Description",
      label: "Comment",
      options: {
        display: false,
        customBodyRender: (val) => {
          return (
            <Tooltip title={<p style={{ fontSize: 14 }}>{val}</p>} arrow placement="top">
              <div className={classes.divComment}>
                <div className={classes.parentStyle}>
                  <div className={classes.cellStyleEllipsis}>{val}</div>
                </div>
              </div>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "CurCode",
      label: "Currency",
    },
    {
      name: "CurRate",
      label: "Rate",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value, "currency");
        },
      },
    },
    {
      name: "DrAmount",
      label: "Dr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrAmount",
      label: "Cr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DrBase",
      label: "Dr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrBase",
      label: "Cr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DimList",
      label: "DimList",
      options: {
        display: false,
      },
    },
  ];

  const footerClasses = clsx({
    [classes.footerCell]: true,
    [classes.stickyFooterCell]: true,
  });

  const options = {
    responsive: "standard",
    selectableRows: "multiple",
    fixedHeader: true,
    tableBodyHeight: "580px",
    search: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    pagination: false,
    customTableBodyFooterRender: function (opts) {
      const sumDrAmt = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[7]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumCrAmt = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[8]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumDrBase = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[9]);
        return NumberFormat(s ?? 0);
      }, 0);

      const sumCrBase = opts.data.reduce((accu, item) => {
        const s = ToNumber(accu) + ToNumber(item.data[10]);
        return NumberFormat(s ?? 0);
      }, 0);
      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            {/* Add TableCellEmpty For Summary Space */}
            <TableCell className={footerClasses} />
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "DrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrAmt}
                    </TableCell>
                  );
                } else if (col.name === "CrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrAmt}
                    </TableCell>
                  );
                } else if (col.name === "DrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrBase}
                    </TableCell>
                  );
                } else if (col.name === "CrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrBase}
                    </TableCell>
                  );
                } else {
                  return <TableCell key={index} className={footerClasses} />;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
    onRowsDelete: (rowsDeleted) => {
      const removeArray = rowsDeleted.data.map((i) => i.index);
      for (var i = removeArray.length - 1; i >= 0; i--) initData.Detail.splice(removeArray[i], 1);
    },
  };

  const CustomHeader = (props) => {
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell align="center" colSpan={1}>
              <IconButton size={"small"} onClick={AddNewRow} style={{ marginLeft: 6 }}>
                <AddIcon />
              </IconButton>
            </TableCell>
            <TableCell align="right" colSpan={10} />
          </TableRow>
        </TableHead>
        <MuiTableHead {...props} />
      </>
    );
  };

  const CheckDrCr = (field, m, data) => {
    const CurRate = ToNumber(data["CurRate"]);
    const DrAmount = ToNumber(data["DrAmount"]);
    const CrAmount = ToNumber(data["CrAmount"]);
    m.setValue("DrBase", DrAmount * CurRate);
    m.setValue("CrBase", CrAmount * CurRate);
    if (field == "DrAmount" && data[field] != 0) {
      m.setValue("DrBase", DrAmount * CurRate);
      m.setValue("CrAmount", 0);
      m.setValue("CrBase", 0);
    }
    if (field == "CrAmount" && data[field] != 0) {
      m.setValue("CrBase", CrAmount * CurRate);
      m.setValue("DrAmount", 0);
      m.setValue("DrBase", 0);
    }
  };

  const CheckValueBeforePost = (values) => {
    if (values.Detail.length > 0) {
      const sumDrBase = values.Detail.reduce((total, cur) => {
        return FixedSumValue(total + ToNumber(cur.DrBase));
      }, 0);
      const sumCrBase = values.Detail.reduce((total, cur) => {
        return FixedSumValue(total + ToNumber(cur.CrBase));
      }, 0);

      if (sumDrBase !== sumCrBase) {
        SnackbarUtils.warning(translate("ra.info.Unbalanced"));
        setBtnLoading(false);
        return false;
      }

      const foundZeroItem = values.Detail.filter(
        (item) => ToNumber(item.DrAmount) === 0 && ToNumber(item.CrAmount) === 0
      );

      if (foundZeroItem.length > 0) {
        const msg = `Amount cannot be zero, would you like to remove transaction(s) ? 
        Note: All transactions with no amounts will be deleted.`;
        SnackbarUtils.confirm(
          msg,
          function () {
            const indexList = foundZeroItem.map((i) => i.index);
            for (let i = indexList.length - 1; i >= 0; i--) {
              values.Detail.splice(indexList[i], 1);
            }
            forceUpdate();
            Save(values);
          },
          function () {
            setBtnLoading(false);
          }
        );
      } else {
        return true;
      }
    } else {
      SnackbarUtils.info(translate("ra.info.notransaction"));
      setBtnLoading(false);
      return false;
    }
  };

  const Save = async (values) => {
    const isPass = CheckValueBeforePost(values);

    values.Detail.map((item) => {
      item.DrAmount = ToNumberFixedFormat(item.DrAmount);
      item.DrBase = ToNumberFixedFormat(item.DrBase);
      item.CrAmount = ToNumberFixedFormat(item.CrAmount);
      item.CrBase = ToNumberFixedFormat(item.CrBase);
      return item;
    });

    if (isPass) {
      SaveFnc(values);
    } else {
      setLoading(false);
    }
  };

  const SaveFnc = async (values) => {
    const { Code, InternalMessage, UserMessage } = await createJvDetail(values);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage, function () {
        redirect(`${InternalMessage}/show`);
      });
      setBtnLoading(false);
    } else {
      setBtnLoading(false);
      if (InternalMessage) {
        SnackbarUtils.error(InternalMessage);
      } else {
        SnackbarUtils.warning(UserMessage);
      }
    }
  };

  const CancelFnc = () => {
    localStorage.removeItem("jvCopyMode");
    localStorage.removeItem("jvId");
    localStorage.removeItem("templateId");
    redirect("list", basePath);
  };

  if (loading) return <Loading />;
  if (!initData) return null;

  return (
    <div
    // className={clsx(classes.drawer, {
    //   [classes.drawerOpen]: openDim,
    //   [classes.drawerClose]: !openDim,
    // })}
    >
      <ActionMenu menuControl={menuControlProp} />
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={disableFormEnter}>
        <Paper style={{ padding: 16 }}>
          <BoxHeader header={"Journal Voucher"} source={initData.JvhSource} status={initData.Status} />
          <Grid container alignItems="flex-start" spacing={1}>
            {formFields
              ? formFields.map((item, idx) => (
                  <Grid item xs={item.size} key={idx}>
                    {React.createElement(item.field.type, {
                      ...{
                        ...item.field.props,
                        methods,
                        key: item.field.props.name,
                      },
                    })}
                  </Grid>
                ))
              : ""}
            <Grid item xs={12}>
              <MuiTranslateTable
                data={initData.Detail}
                columns={columns}
                options={options}
                components={{
                  TableHead: CustomHeader,
                }}
              />
              {showAdd && (
                <PopupTable
                  initialValues={editIndex !== "" ? initData.Detail.find((i) => i.index === editIndex) : initNewRow}
                  formFields={formFieldsDetail}
                  update={CheckDrCr}
                  open={showAdd}
                  save={(row) => SaveFromPopup(initData, row)}
                  cancel={CancelFromPopup}
                  showDim
                />
              )}
            </Grid>
          </Grid>
        </Paper>
        <pre>{process.env.NODE_ENV === "development" ? JSON.stringify(initData, 0, 2) : ""}</pre>
        <ButtonFooter disabled={isBtnLoading} CancelFnc={CancelFnc} />
      </form>
      {selectTemplateDialog && <DialogSelectTemplate open={selectTemplateDialog} onClose={CloseSelectTemplateDialog} />}
    </div>
  );
};

export default Create;
